import GenericIdValue from "./GenericIdValue";
import GenericTextValue from "./GenericTextValue";

export default class AmountSizeUnit {
  constructor(name, initialValue, namespace, amountNameSpace, sizeUnitNameSapace) {
    this.namespace=namespace;
    this.name=name;
    this.amount=new GenericTextValue("amount", null, amountNameSpace);
    this.sizeUnit=new GenericIdValue("sizeUnit", null, sizeUnitNameSapace);
    if (initialValue) {
      this.parseInputJSON(initialValue);
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getAmountObj() {
    return this.amount;
  }

  getSizeUnitObj() {
    return this.sizeUnit;
  }

  setAmountObj(amountObj) {
    this.amount=amountObj;
  }

  setSizeUnitObj(sizeUnitObj) {
    this.sizeUnit=sizeUnitObj;
  }

  getExpandedFormatValue() {
    const amountExpanded=this.amount.getExpandedFormatValue(true);
    const sizeUnitExpanded=this.sizeUnit.getExpandedFormatValue();
    const ob={[this.amount.getNameSpace()]: amountExpanded, [this.sizeUnit.getNameSpace()]: sizeUnitExpanded};
    return ob;
  }

  isEmpty() {
    return this.amount.isEmpty() && this.sizeUnit.isEmpty();
  }

  parseInputJSON(inputJSON) {
    this.amount.parseInputJSON(inputJSON);
    this.sizeUnit.parseInputJSON(inputJSON);
  }
}
